var map = {
	"./axj-button/index.vue": "BK7r",
	"./axj-file-preview/index.vue": "XYhG",
	"./axj-message-prop/index.vue": "TQYp",
	"./axj-upload/index.vue": "8jzF",
	"./axj-web-certs/components/axj-login/index.vue": "gU3g",
	"./axj-web-certs/components/axj-register/index.vue": "gXza",
	"./axj-web-certs/components/axj-wx/index.vue": "w048",
	"./axj-web-certs/index.vue": "qg+m",
	"./axj_wx_cert/index.vue": "sMUW",
	"./axj_wx_login/index.vue": "zsZG",
	"./common/button/axj-button.vue": "wwgU",
	"./common/preview/index.vue": "Ttlj",
	"./common/search/major.vue": "AKgz",
	"./common/search/school.vue": "tYc3",
	"./common/upload/index.vue": "46hw",
	"./d2-avatar-uploader/component.vue": "OnvF",
	"./d2-icon/component.vue": "pUA9",
	"./d2-quill/component.vue": "U62i",
	"./stu-input/stu-input-size-limit/index.vue": "NvQU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GmZK";


//////////////////
// WEBPACK FOOTER
// ./src/components .vue$
// module id = GmZK
// module chunks = 1